<template>
  <div class="m-card gradient">
    <h2 style="font-weight: bold">Machine list</h2>
    <vs-table max-items="10" pagination :data="listMachine">
      <template slot="header"> </template>
      <template slot="thead">
        <vs-th> </vs-th>
        <vs-th> <div class="th-text-center">ไลน์เครื่องจักร/แผนก</div> </vs-th>
        <vs-th> <div class="th-text-center">เลขรหัสประจำเครื่อง</div> </vs-th>
        <vs-th> <div class="th-text-center">ชื่อเครื่องจักร</div> </vs-th>
        <vs-th> <div class="th-text-center">ยี่ห้อเครื่องจักร</div> </vs-th>
        <vs-th> <div class="th-text-center">รุ่นเครื่องจักร</div> </vs-th>
        <vs-th> <div class="th-text-center">ผู้รับผิดชอบ</div> </vs-th>
        <vs-th> <div class="th-text-center">Tel.</div> </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr
          :key="indextr"
          v-for="(tr, indextr) in data"
          style="text-align: center"
        >
          <vs-td>
            <vs-button
              color="success"
              type="flat"
              icon="add"
              :to="'/cpf/machine/' + data[indextr].id"
              >view</vs-button
            >
          </vs-td>

          <vs-td :data="data[indextr].line">
            {{ data[indextr].line }}
          </vs-td>

          <vs-td :data="data[indextr].serial">
            {{ data[indextr].serial}}
          </vs-td>

          <vs-td :data="data[indextr].name">
            {{ data[indextr].name }}
          </vs-td>

          <vs-td :data="data[indextr].brand">
            {{ data[indextr].brand }}
          </vs-td>

          <vs-td :data="data[indextr].model">
            {{ data[indextr].model }}
          </vs-td>

          <vs-td :data="data[indextr].officer">
            {{ data[indextr].officer }}
          </vs-td>

          <vs-td :data="data[indextr].phone">
            {{ data[indextr].phone }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fakeData: [],
      listMachine: [],
      arrayName: [
        "ผกาพรรณ ศิลามหาฤกษ์",
        "พรทิพา ศิลามหาฤกษ์",
        "จินตพร ครองจินดา",
        "บัณฑิต จุฑาเทพ ณ อยุธยา",
        "อานันท์ กองการ",
        "ภาณุภัทร พิทักษ์ไทย",
        "กฤตยา พรรณาราย",
        "กฤษฎา พิทักษ์ไทย",
        "พรนภา จิตประสงค์",
        "กนกพรรณ เกิดความสุข",
        "ดนุเดช วรเลิศรัตน์",
        "ชนกนันท์ กล้านอนหงาย",
        "จุฑามณี นิมิตนาม",
        "ดนุเดช พิทักษ์ไทย",
        "ไอริณ ศิวาวงศ์ ",
        "กนกอร ประภาพร ",
        "กชวรรณ พรรณาราย",
        "ปฏิพล พงศ์พิทักษ์",
        "จุไรวรรณ มหานิยม",
        "ปิยนุช จิรามณี",
        "ภูวเดช วิทยเขตปภา",
      ],
    };
  },
  computed: {
    fakeDataCom: function () {
      return this.fakeData;
    },
  },
  mounted() {
    // let dep = 1;
    // let nameMachine = ["เครื่องบดอาหาร", "พัดลม", "ตู้กรองฝุ่น"];
    // for (let i = 1; i <= 20; i++) {
    //   let no = (i / 1000).toFixed(3);
    //   let j = i % 21;
    //   let data = {
    //     id: "บด" + dep,
    //     name: nameMachine[i % 3] + " บด" + dep,
    //     mac: "211" + no.slice(2),
    //     model: "BUHLER",
    //     admin: this.arrayName[j],
    //     tel: "0910001111",
    //   };
    //   this.fakeData.push(data);
    //   console.log(data.dis);
    //   dep = i % 3 == 0 ? dep + 1 : dep;
    // }
    this.getListMachine();
  },
  methods: {
    async getListMachine() {
      try {
        let res = await this.$API.get(`CPF-getinfo`);
        console.log("cpf/getmachine/", res);
        this.listMachine = res.data.message;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.gradient {
  background: linear-gradient(
    180deg,
    #32c040 0%,
    var(--background-color-sidebar) 50px,
    var(--background-color-sidebar) 100%
  );
  //   font-weight: bold;
}
.th-text-center {
  width: 100%;
  text-align: center;
}
</style>